import React, { useMemo } from 'react';
import RxntPharmacyPicker from '../../../components/Rxnt/RxntPharmacyPicker';
import {
  clearEmployeePreferredPharmacyFields,
  employeePreferredPharmacyFieldsFromGateway,
  pharmacyFiltersFromEmployee,
  selectedPharmacyFromEmployee,
} from '../../../utils/rxntUiUtils';

const PatientPreferredPharmacy = ({
  formData,
  patchFormDataHandler,
  employeeId,
  Toast,
}) => {
  const selectedPharmacy = useMemo(
    () => selectedPharmacyFromEmployee(formData),
    [
      formData?.preferred_rxnt_pharmacy_id,
      formData?.preferred_pharmacy_name,
      formData?.preferred_pharmacy_address,
      formData?.preferred_pharmacy_phone,
      formData?.preferred_pharmacy_fax,
    ]
  );

  const initialFilters = useMemo(
    () => pharmacyFiltersFromEmployee(formData),
    [
      formData?.preferred_rxnt_pharmacy_id,
      formData?.preferred_pharmacy_name,
      formData?.preferred_pharmacy_address,
      formData?.preferred_pharmacy_phone,
      formData?.preferred_pharmacy_fax,
    ]
  );

  const handleSelect = (pharmacy) => {
    if (patchFormDataHandler) {
      patchFormDataHandler(employeePreferredPharmacyFieldsFromGateway(pharmacy));
    }
  };

  const handleClear = () => {
    if (patchFormDataHandler) {
      patchFormDataHandler(clearEmployeePreferredPharmacyFields());
    }
  };

  return (
    <RxntPharmacyPicker
      key={employeeId || 'employee-pharmacy'}
      idPrefix="employee_preferred_pharmacy"
      title="Preferred pharmacy (RXNT)"
      selectedPharmacy={selectedPharmacy}
      initialFilters={initialFilters}
      filtersSyncKey={formData?.preferred_rxnt_pharmacy_id ?? ''}
      onSelect={handleSelect}
      onClear={handleClear}
      Toast={Toast}
    />
  );
};

export default PatientPreferredPharmacy;
